import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { LettersApi, type CreateLetterWithAttachment } from '@shared/api';

interface UseCreateLetterWithAttachmentsStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  createLetterWithAttachments: (request: CreateLetterWithAttachment, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreateLetterWithAttachmentsStore = create<UseCreateLetterWithAttachmentsStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  createLetterWithAttachments: async (request, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await LettersApi.createLetterWithAttachments(request, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  },

  clear: () => set({ loading: false, error: null, success: false }),
}));
